var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar"},[_c('img',{attrs:{"src":require("../assets/images/logo-white.png")}}),_c('h2',[_vm._v("APEX ToolBox")]),_c('span',[_vm._v(_vm._s(_vm.user))])])
}
var staticRenderFns = []

export { render, staticRenderFns }